import { defineLegacyDefaultTheme } from './defineLegacyDefaultTheme';

/** A pale violet-grey with a rich plum accent. */
export const decepticonTheme = defineLegacyDefaultTheme({
  id: 'Decepticon',
  tokens: {
    a0: { l: 0.52, c: 0.18, h: 295 },
    a1: { l: 0.52, c: 0.18, h: 335 },
    a2: { l: 0.52, c: 0.18, h: 15 },
    a3: { l: 0.52, c: 0.18, h: 55 },
    a4: { l: 0.52, c: 0.18, h: 95 },
    b0: { l: 0.98, c: 0.006, h: 295 },
    b1: { l: 0.96, c: 0.008, h: 295 },
    b2: { l: 0.93, c: 0.01, h: 295 },
    b3: { l: 0.95, c: 0.008, h: 295 },
    b4: { l: 0.93, c: 0.01, h: 295 },
    c0: { l: 0.23, c: 0.014, h: 295 },
    c1: { l: 0.4, c: 0.012, h: 295 },
    c2: { l: 0.52, c: 0.01, h: 295 },
    c3: { l: 0.62, c: 0.008, h: 295 },
    c4: { l: 0.72, c: 0.006, h: 295 },
  },
});
